import settingsStore from './../stores/settings';
import SmartQ from '../smartq_js/SmartQ';
import QueueItem from '../smartq_js/QueueItem';

const lessThanSixHoursAgo = (date) => {
    
    
  const HOUR = 1000 * 60 * 60;
  const sixHoursAgo = Date.now() - (6 * HOUR);
  return date > sixHoursAgo;
};

const smartQPlayQueue = (playQueue) => {
    
    
  let waitingList = [];
  if (playQueue) {
    if (playQueue.items) {
      for (let i = 0; i < playQueue.items.length; i++) {
        let performance = playQueue.items[i];
        let item = new QueueItem();
        item.itemId = performance.unique_id;
        item.performance = performance;
        item.singerId = performance.profile.id;
        item.timeEntered = new Date(performance.created).getTime() / 1000;
        item.isManual = performance.isManual ? performance.isManual : false;
        waitingList.push(item);
      }
    }
  }
  return waitingList;
}

const createSmartQHistory = (history) => {
    
    
  let playQueueHistory = history;
  let smartQHistory = [];
  if (playQueueHistory) {
    for (let i = 0; i < playQueueHistory.items.length; i++) {
      let performance = playQueueHistory.items[i];
      let timePlayed = new Date(performance.played).getTime();
      if (lessThanSixHoursAgo(timePlayed)) {
        let item = new QueueItem();
        item.itemId = performance.unique_id;
        item.performance = performance;
        item.singerId = performance.profile.id;
        item.timeEntered = new Date(performance.created).getTime() / 1000;
        item.timePlayed = timePlayed / 1000;
        item.isManual = false;
        smartQHistory.push(item);
      }
    }
  }
  return smartQHistory;
}

const createNewPlayQueue = (newPerformanceList) => {
    
    
  let newPlayQueueItems = [];
  let duration = 0;
  for (let i = 0; i < newPerformanceList.length; i++) {
    let performance = newPerformanceList[i].performance;
    performance.position = i;
    performance.incoming = duration;
    duration += performance.track.length.split(':').reduce((acc, time) => (60 * acc) + +time);
    newPlayQueueItems.push(performance);
  }
  return newPlayQueueItems;
}

export function sortBySmartQ(playQueue, history) {
  let smartq = new SmartQ();
  smartq.setNumLocked(2);
  smartq.setAutoPattern(true);
  smartq.setQueue(smartQPlayQueue(playQueue));
  smartq.setHistory(createSmartQHistory(history));
  smartq.update();
  let newPerformanceList = smartq.getQueue();
  playQueue.items = createNewPlayQueue(newPerformanceList);
  return playQueue;
}